"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("../../../assets/images/icon-01.svg");
require("../../../assets/images/dc-team-calendar.svg");
var angular_1 = __importDefault(require("angular"));
var instructor_dashboard_html_1 = __importDefault(require("./instructor-dashboard.html"));
var instructor_calendar_module_1 = __importDefault(require("./calendar/instructor-calendar.module"));
var instructor_teamcalendar_module_1 = __importDefault(require("./teamcalendar/instructor-teamcalendar.module"));
var instructor_agenda_module_1 = __importDefault(require("./agenda/instructor-agenda.module"));
var instructor_teamagenda_module_1 = __importDefault(require("./teamagenda/instructor-teamagenda.module"));
var instructor_upcoming_students_report_cards_module_1 = __importDefault(require("./report-cards/instructor-upcoming-students-report-cards.module"));
var pending_report_cards_module_1 = __importDefault(require("./pending-report-cards/pending-report-cards.module"));
var grade_graded_report_card_module_1 = __importDefault(require("./create-report-card/grade-graded-report-card.module"));
var create_pass_fail_report_card_module_1 = __importDefault(require("./create-pass-fail-report-card/create-pass-fail-report-card.module"));
var grade_generic_report_card_module_1 = __importDefault(require("./grade-generic-report-card/grade-generic-report-card.module"));
var instructor_edit_contact_info_module_1 = __importDefault(require("./edit/instructor-edit-contact-info.module"));
var instructor_edit_certification_module_1 = __importDefault(require("./certifications/instructor-edit-certification.module"));
var instructor_log_hours_module_1 = __importDefault(require("./log-hours/instructor-log-hours.module"));
var instructor_course_module_1 = __importDefault(require("./course/instructor-course.module"));
var instructor_courses_index_module_1 = __importDefault(require("./courses/index/instructor-courses-index.module"));
var instructor_event_module_1 = __importDefault(require("./event/instructor-event.module"));
var instructor_view_drive_module_1 = __importDefault(require("./drive/instructor-view-drive.module"));
var instructor_request_time_off_module_1 = __importDefault(require("./request-time-off/instructor-request-time-off.module"));
var instructor_view_time_off_requests_module_1 = __importDefault(require("./time-off-requests/instructor-view-time-off-requests.module"));
var instructor_dashboard_controller_1 = __importDefault(require("./instructor-dashboard.controller"));
var student_orders_module_1 = __importDefault(require("./student-orders/student-orders.module"));
var student_drives_module_1 = __importDefault(require("./student-drives/student-drives.module"));
var view_student_module_1 = __importDefault(require("./view-student/view-student.module"));
var instructor_cancel_drive_module_1 = __importDefault(require("./cancel-drive/instructor-cancel-drive.module"));
var student_reportcards_module_1 = __importDefault(require("./student-reportcards/student-reportcards.module"));
var report_card_module_1 = __importDefault(require("./report-card/report-card.module"));
var instructor_create_drive_module_1 = __importDefault(require("./create-drive/instructor-create-drive.module"));
var instructor_create_order_module_1 = __importDefault(require("./create-order/instructor-create-order.module"));
var orders_module_1 = __importDefault(require("./orders/orders.module"));
var order_module_1 = __importDefault(require("./order/order.module"));
var instructor_complete_drive_module_1 = __importDefault(require("./complete-drive/instructor-complete-drive.module"));
var student_notes_module_1 = __importDefault(require("./student-notes/student-notes.module"));
function config($stateProvider, $urlRouterProvider, USER_ROLES) {
    $stateProvider
        .state('drivecoach.instructor.dashboard', {
        url: '/dashboard',
        template: instructor_dashboard_html_1.default,
        controller: 'InstructorDashboardController',
        controllerAs: 'vm',
        data: {
            authorizedRoles: [
                USER_ROLES.admin,
                USER_ROLES.owner,
                USER_ROLES.instructor
            ]
        }
    });
}
config.$inject = ['$stateProvider', '$urlRouterProvider', 'USER_ROLES'];
exports.default = angular_1.default.module('instructor.dashboard', [
    instructor_calendar_module_1.default.name,
    instructor_teamcalendar_module_1.default.name,
    instructor_agenda_module_1.default.name,
    instructor_teamagenda_module_1.default.name,
    instructor_upcoming_students_report_cards_module_1.default.name,
    pending_report_cards_module_1.default.name,
    grade_graded_report_card_module_1.default.name,
    create_pass_fail_report_card_module_1.default.name,
    grade_generic_report_card_module_1.default.name,
    instructor_edit_contact_info_module_1.default.name,
    instructor_edit_certification_module_1.default.name,
    instructor_log_hours_module_1.default.name,
    instructor_course_module_1.default.name,
    instructor_courses_index_module_1.default.name,
    instructor_event_module_1.default.name,
    instructor_view_drive_module_1.default.name,
    instructor_request_time_off_module_1.default.name,
    instructor_view_time_off_requests_module_1.default.name,
    student_orders_module_1.default.name,
    student_drives_module_1.default.name,
    view_student_module_1.default.name,
    instructor_cancel_drive_module_1.default.name,
    student_reportcards_module_1.default.name,
    report_card_module_1.default.name,
    instructor_create_drive_module_1.default.name,
    instructor_create_order_module_1.default.name,
    orders_module_1.default.name,
    order_module_1.default.name,
    instructor_complete_drive_module_1.default.name,
    student_notes_module_1.default.name,
])
    .config(config)
    .controller('InstructorDashboardController', instructor_dashboard_controller_1.default);
